import { render, staticRenderFns } from "./EsqueciSenha.vue?vue&type=template&id=9711a45c&scoped=true&"
import script from "./EsqueciSenha.vue?vue&type=script&lang=js&"
export * from "./EsqueciSenha.vue?vue&type=script&lang=js&"
import style0 from "./EsqueciSenha.vue?vue&type=style&index=0&id=9711a45c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9711a45c",
  null
  
)

export default component.exports